import { loadStripe } from '@stripe/stripe-js';

const test = false;

function getStripePublicKey() {
    if (test) {
        return "pk_test_51HXqCYL1Q5LbbIz3tWVMflglZYjffYVVFE8ovwGC4IoIoXXLFIWjpBNzTfNVhIx5hyuAAL9DzUoO9NfFeTi04p2i00sGkjUgN4"
    } else {
        return "pk_live_51HXqCYL1Q5LbbIz3e7Pyz1nILCeRsFDvLwMNKyR3TEP1hpNp13firkmVfLEQyudpbPXFRGI8cZVhFB9CX8Nr3LGF00u7JSW6bK"
    }
}

export enum Productos {
    PREMIUM_1 = "premium_1",
    PREMIUM_2 = "premium_2",
    PREMIUM_6 = "premium_6",
    PREMIUM_12 = "premium_12",
    CREDITOS_100 = "creditos_100",
    CREDITOS_500 = "creditos_500",
}

function obtenerProducto(producto: Productos) {
    if (test) {//Tests
        switch (producto) {
            case Productos.PREMIUM_1:
                return "price_1HY51NL1Q5LbbIz3H0Y4v8EB";
            case Productos.PREMIUM_2:
                return "price_1HY51NL1Q5LbbIz3H0Y4v8EB";
            case Productos.PREMIUM_6:
                return "price_1HY51NL1Q5LbbIz3H0Y4v8EB";
            case Productos.PREMIUM_12:
                return "price_1HY51NL1Q5LbbIz3H0Y4v8EB";
            case Productos.CREDITOS_100:
                return "price_1TM0aiL1Q5LbbIz3I1c0w0wD";
            case Productos.CREDITOS_500:
                return "price_1TM0aiL1Q5LbbIz3I1c0w0wD";
        }
    } else {
        switch (producto) {
            case Productos.PREMIUM_1:
                return "price_1HY558L1Q5LbbIz3zHXf1EIr";
            case Productos.PREMIUM_2:
                return "price_1HYADDL1Q5LbbIz37EJO56Dv";
            case Productos.PREMIUM_6:
                return "price_1HYAEVL1Q5LbbIz3SQIVudZd";
            case Productos.PREMIUM_12:
                return "price_1HYAExL1Q5LbbIz3hgn1kFe4";
            case Productos.CREDITOS_100:
                return "price_1HYAFvL1Q5LbbIz3Yf7mLnXp";
            case Productos.CREDITOS_500:
                return "price_1HYAGPL1Q5LbbIz3W0Ihxh04";
        }
    }
}

export function pago_producto(producto: Productos, cancelURL: string, successURL: string, email: string) {
    const stripe = loadStripe(getStripePublicKey());
    const usarProducto = obtenerProducto(producto);

    stripe.then((stripeData) => {
        stripeData?.redirectToCheckout({
            lineItems: [{ price: usarProducto, quantity: 1 }],
            mode: 'payment',
            successUrl: successURL,
            cancelUrl: cancelURL,
            customerEmail: email,
        });
    });
}
